import axios from 'axios'
import jwtDecode from 'jwt-decode'
import API from '../utils/api'
import { publish } from './events'
import utils from './utils'
import { buildCloseSessionsPath, getFullReturnPath } from '@/modules/auth/utils/auth-return'

axios.defaults.headers.common['PW-Platform'] = 'web'
axios.defaults.headers.common['PW-Version'] = '2.1'

// Checks if the token is valid and not expired
export function isValidToken (token) {
  if (!token || token === null || token === undefined || token === 'undefined') {
    return false
  }

  const decode = jwtDecode(token)
  // expiration time logout the user
  const expirationTime = decode.exp * 1000
  const isValid = Date.now() < expirationTime

  if (isValid) {
    setSession(token)
  }

  return isValid
}

export function setSession (token) {
  if (token && token !== 'undefined') {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
    utils.setToken(token)
  }
}

export function logoutSession () {
  const sessionKeys = [
    'isAuth',
    'user',
    'balance',
    'allowed',
    'jwtoken',
    'referer',
    'prevPoolId',
    'redirectTo',
    'userLoyalty',
    'popUpNewUser',
    'mobileBanner',
    'readyToVerify',
    'prevBracketId',
    'isNewFlowActive',
    'showGameFreeRoll',
    'showGameTutorial',
    'hasSentAnalytics',
    'misQuinielasItems',
    'showTutorialLobby',

    // For new context the others will be removed
    // When all will be migrated to user context
    'user-context',
    'availableCashout-context',
    'setUserBalance-context',
    'promotions-context',
    'userLoyalty-context'
  ]

  sessionKeys.forEach(key => window.localStorage.removeItem(key))

  publish('LOGOUT_SUCCESS')
}

// Routes where we should not force /close-sessions
export function shouldSkipCloseSessionsRedirect (pathname = window.location.pathname) {
  return (
    pathname === '/close-sessions' ||
    pathname === '/validar-usuario' ||
    pathname === '/legal' ||
    pathname.startsWith('/legal/')
  )
}

// Check other user sessions. Resolves `true` if a redirect was triggered.
export function validateUserSessions () {
  return new Promise(resolve => {
    if (!utils.getToken()) {
      resolve(false)
      return
    }

    API.checkOtherSessionsUser()
      .then((response) => {
        if (
          response?.data?.active_sessions &&
          !shouldSkipCloseSessionsRedirect(window.location.pathname)
        ) {
          window.location = buildCloseSessionsPath(getFullReturnPath(window.location))
          resolve(true)
          return
        }
        resolve(false)
      })
      .catch(() => resolve(false))
  })
}
